module.exports = __webpack_public_path__ + "static/media/small-blue-back-icon.4f8bad51.svg";